import { render } from "./visitorGeneral.vue?vue&type=template&id=3d6c1940"
import script from "./visitorGeneral.vue?vue&type=script&lang=js"
export * from "./visitorGeneral.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__